import React from 'react';

const GoalListing = props => {
  const { title } = props;
  return (
    <div
      style={{
        backgroundColor: '#2270AF',
        borderRadius: '35px',
        width: '250px',
        height: '250px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        alignSelf: 'flex-start',
        margin: '2%',
      }}
    >
      <h2 style={{ color: 'white' }}>{title}</h2>
      <div>
        <button
          style={{
            backgroundColor: 'rgb(185 51 125)',
            borderRadius: '10px',
            width: '120px',
            height: '49px',
            color: 'white',
            fontSize: '16px',
          }}
          onClick={props.onClick}
        >
          Manage
        </button>
      </div>
    </div>
  );
};

export default GoalListing;
